import React from "react";
import styled from "styled-components";

export default styled.section`
    width: 338px;
    background: white;
    position: absolute;
    bottom: 0;
    z-index: 3;
    transition: 100ms all linear;
    padding: 22px 23px;
    box-sizing: border-box;
    min-height: 100px;
    border: 1px solid gray;
    box-shadow: 5px 5px 25px #00000054;
    height: 100vh;
    left: -338px;
    top: 0;
    padding-top: 0;
    
    ${(props) => (props.open ? {
    'left': '80px',
} : '')}
`;